module.exports = __webpack_public_path__ + "img/popularize03.fd10a7a4.png";